module.exports = __webpack_public_path__ + "img/authPicture.51d76f55.png";